import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { accountType, accountUsage } from "./../../../utils/data/account_type";
import {
  deleteChartOfAccount,
  editChartAccount,
  getGlGroups,
  resetChartOfAccountStatus,
} from "../../../redux/slice/accounting/accountingSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Select from "../../form/select/Select";

const EditAccount = ({ modal_id, singleAccount }) => {
  const [hasEditAccounts, setHasEditAccounts] = useState();
  const [hasDeleteAccounts, setHasDeleteAccounts] = useState();
  const { gl_groups, isUpdated } = useSelector((state) => state?.accounting);
  const [glgroup, setGlgroup] = useState({ error: "", account_type: "" });
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const close = useRef();
  const selectRef = useRef();
  const accountUsageSelectRef = useRef();
  const GLSelectRef = useRef();
  const form = useRef();
  const manualEntryRef = useRef();
  const accountDisabledRef = useRef();
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    let payload = {
      ...values,
      id: singleAccount?.id,
      balance: 0,
    };
    if (values?.account_usage === 1) {
      setGlgroup({ ...glgroup, error: "" });
    }

    // if (!values?.gl_group && values?.account_usage === 2) {
    //   setGlgroup({ ...glgroup, error: "GL group cannot be blank" });
    //   return;
    // }

    if (values?.account_usage == "1") {
      const { gl_group, ...remaining } = payload;
      if (!values?.external_id) {
        const { external_id, ...rest } = remaining;
        dispatch(editChartAccount(rest));
        return;
      }
      dispatch(editChartAccount(remaining));
    } else {
      if (!values?.external_id) {
        const { external_id, ...rest } = payload;
        dispatch(editChartAccount(rest));
        return;
      }
      dispatch(editChartAccount(payload));
    }
  };

  const validationScehma = Yup.object().shape({
    account_name: Yup.string("Account Name must be a string").required(
      "Account Name cannot be blank"
    ),
    gl_code: Yup.string("GL code must be a string").required(
      "GL Code cannot be blank"
    ),
    account_usage: Yup.string("Account Usage must be a string").required(
      "Account Usage cannot be blank"
    ),
    account_type: Yup.string("Account type must be a string").required(
      "Account type cannot be blank"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      account_name: singleAccount?.account_name || "",
      gl_code: singleAccount?.gl_code || "",
      external_id: singleAccount?.external_id || "",
      account_usage: singleAccount?.account_usage || "",
      manual_entries: (singleAccount?.manual_entries !== null && true) || false,
      gl_group: singleAccount?.gl_group || "",
      description: singleAccount?.description || "",
      disabled: (singleAccount?.disabled == 1 && true) || false,
      account_type: singleAccount?.account_type || "",
    },
    validationSchema: validationScehma,
    onSubmit,
    onReset: () => {
      selectRef?.current?.clearValue();
      accountUsageSelectRef?.current?.clearValue();
      GLSelectRef?.current?.clearValue();
    },
  });

  useEffect(() => {
    resetForm();
    if (isUpdated) {
      close.current?.click();
      if (manualEntryRef.current.checked) {
        manualEntryRef.current.checked = false;
      }
      if (accountDisabledRef.current.checked) {
        accountDisabledRef.current.checked = false;
      }
      resetForm();
      dispatch(resetChartOfAccountStatus());
    }
  }, [isUpdated]);

  useEffect(() => {
    if (values?.account_type) {
      dispatch(getGlGroups(values?.account_type));
    }
  }, [values?.account_type]);

  useEffect(() => {
    if (singleAccount?.manual_entries) {
      manualEntryRef.current.checked = true;
    }
    if (singleAccount?.disabled) {
      accountDisabledRef.current.checked = true;
    }
  }, [singleAccount?.uuid]);

  useEffect(() => {
    setHasEditAccounts(
      user_permissions?.some(
        (permission) => permission.name === "edit general ledger account"
      )
    );
    setHasDeleteAccounts(
      user_permissions?.some(
        (permission) => permission.name === "delete general ledger account"
      )
    );
  }, [user_permissions]);

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <form
            className='modal-content rounded-4'
            onSubmit={handleSubmit}
            ref={form}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Edit a General Ledger Account
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                style={{ padding: "0px 3px" }}
                onClick={() => {
                  if (manualEntryRef.current.checked) {
                    manualEntryRef.current.checked = false;
                  }
                  if (accountDisabledRef.current.checked) {
                    accountDisabledRef.current.checked = false;
                  }
                  resetForm();
                }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='px-3'>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='username'
                      className={`form-label mt-1  ${
                        errors?.account_name &&
                        touched?.account_name &&
                        "text-danger"
                      }`}
                    >
                      Account Name <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='text'
                      id='account_name'
                      name='account_name'
                      className={`form-control form-control-sm ${
                        errors?.account_name &&
                        touched?.account_name &&
                        "is-invalid"
                      }`}
                      value={values?.account_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.account_name && touched?.account_name && (
                      <p className='text-danger  mb-0'>
                        {errors?.account_name}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='gl_code'
                      className={`form-label mt-1 ${
                        errors?.gl_code && touched?.gl_code && "text-danger"
                      }`}
                    >
                      GL Code <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      className={`form-control form-control-sm ${
                        errors?.gl_code && touched?.gl_code && "is-invalid"
                      }`}
                      name='gl_code'
                      value={values?.gl_code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type='text'
                      id='gl_code'
                    />
                    {errors?.gl_code && touched?.gl_code && (
                      <p className='text-danger  mb-0'>{errors?.gl_code}</p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='account_type'
                      className={`form-label mt-1 ${
                        errors?.account_type && touched?.account_type
                          ? "text-danger"
                          : ""
                      }`}
                    >
                      Account Type <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <Select
                      ref={selectRef}
                      isError={errors?.account_type && touched?.account_type}
                      name='account_type'
                      data={accountType.map((item, i) => ({
                        label: item,
                        value: i + 1,
                      }))}
                      value={values.account_type}
                      onChange={(selectedOption) => {
                        setFieldValue("gl_group", "");
                        GLSelectRef?.current?.clearValue();
                        setFieldValue("account_type", selectedOption?.value);
                      }}
                      onBlur={() => {
                        handleBlur({ target: { name: "account_type" } });
                      }}
                    />
                    {errors?.account_type && touched?.account_type && (
                      <p className='text-danger mb-0'>{errors?.account_type}</p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='external_id'
                      className='form-label'
                      style={{ textAlign: "right" }}
                    >
                      External ID
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      className='form-control form-control-sm'
                      type='text'
                      id='external_id'
                      value={values?.external_id}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='account_usage'
                      className={`form-label mt-1 ${
                        errors?.account_usage &&
                        touched?.account_usage &&
                        "text-danger"
                      }`}
                    >
                      Account Usage <span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <Select
                      ref={accountUsageSelectRef}
                      isError={errors?.account_usage && touched?.account_usage}
                      name='account_usage'
                      id='account_usage'
                      data={accountUsage.map((item, i) => ({
                        label: item,
                        value: i + 1,
                      }))}
                      value={values.account_usage}
                      onChange={(selectedOption) => {
                        setFieldValue("account_usage", selectedOption?.value);
                        if (selectedOption?.value === 1) {
                          setGlgroup({
                            ...glgroup,
                            error: "",
                          });

                          GLSelectRef?.current?.clearValue();
                        }
                      }}
                      onBlur={() => {
                        handleBlur({ target: { name: "account_usage" } });
                      }}
                      // disabled={true}
                    />
                    {errors?.account_usage && touched?.account_usage && (
                      <p className='text-danger  mb-0'>
                        {errors?.account_usage}
                      </p>
                    )}
                  </div>
                </div>
                {values?.account_usage === 2 && (
                  <div className='row mb-3'>
                    <div className='col-md-4 text-end sm-text-end'>
                      <label htmlFor='gl_group' className={`form-label`}>
                        GL Groups
                      </label>
                    </div>
                    <div className='col-md-8'>
                      <Select
                        ref={GLSelectRef}
                        isError={glgroup?.error && true}
                        name='gl_group'
                        id='gl_group'
                        data={gl_groups.map((item, i) => ({
                          label: item,
                          value: item,
                        }))}
                        value={values.gl_group}
                        onChange={(selectedOption) =>
                          setFieldValue("gl_group", selectedOption?.value)
                        }
                        // disabled={true}
                      />
                      {glgroup?.error && (
                        <p className='text-danger'>{glgroup?.error}</p>
                      )}
                    </div>
                  </div>
                )}

                <div className='flex align-items-end'>
                  <label
                    className='form-label'
                    htmlFor='manual_entries'
                    style={{
                      textAlign: "right",
                      paddingRight: "25px",
                      width: "35%",
                    }}
                  >
                    <p>Manual entries Allowed?</p>
                  </label>
                  <input
                    className={`form-check-input`}
                    type='checkbox'
                    id='manual_entries'
                    name='manual_entries'
                    // value={values.manual_entries}
                    // defaultChecked={values.manual_entries}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    ref={manualEntryRef}
                    style={{ height: "22px", width: "20px" }}
                  />
                </div>
                <div className='flex align-items-end mb-2'>
                  <label
                    className='form-label'
                    htmlFor='disabled'
                    style={{
                      textAlign: "right",
                      paddingRight: "25px",
                      width: "35%",
                    }}
                  >
                    <p>Disable Account</p>
                  </label>
                  <input
                    className={`form-check-input`}
                    type='checkbox'
                    id='disabled'
                    name='disabled'
                    ref={accountDisabledRef}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ height: "22px", width: "20px" }}
                  />
                </div>

                <div className='row'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label htmlFor='' className={`form-label `}>
                      Description
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <textarea
                      className='form-control'
                      id='description'
                      name='description'
                      value={values?.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder='Enter description here'
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer me-3'>
              {hasEditAccounts && (
                <button
                  type='submit'
                  className='btn btn-primary btn-sm rounded-'
                >
                  Edit
                </button>
              )}
              {hasDeleteAccounts && (
                <button
                  type='button'
                  className='btn btn-danger btn-sm rounded-'
                  onClick={() =>
                    dispatch(deleteChartOfAccount(singleAccount?.id))
                  }
                >
                  Delete
                </button>
              )}
              <button
                type='button'
                className='btn btn-secondary btn-sm rounded-'
                data-bs-dismiss='modal'
                onClick={() => {
                  if (manualEntryRef.current.checked) {
                    manualEntryRef.current.checked = false;
                  }
                  if (accountDisabledRef.current.checked) {
                    accountDisabledRef.current.checked = false;
                  }
                  resetForm();
                }}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditAccount;
